import request from "@/utils/request";
export function findShipper(query) {
  return request({
    url: "/ntocc-basic-api/shipment",
    method: "get",
    params: query
  });
}
export function commodityType(query) {
  return request({
    url: "/ntocc-basic-api/goodsType/getByParentCode",
    method: "get",
    params: query
  });
}
export function insuranceType(query) {
  return request({
    url: "/ntocc-basic-api/dict",
    method: "get",
    params: query
  });
}
export function VehicleType(query) {
  return request({
    url: "/ntocc-basic-api/dict",
    method: "get",
    params: query
  });
}

// 行业树开关
export function isTreeOpen(query) {
  return request({
    url: "/ntocc-basic-api/industry/isOpen",
    method: "get",
    params: query
  });
}
// 行业树
export function industryTree(query) {
  return request({
    url: "/ntocc-basic-api/industry/tree",
    method: "get",
    params: query
  });
}
// 云平台开关
export function isRainbowOn(query) {
  return request({
    url: "/ntocc-tms-api/order/isRainbowOn",
    method: "get",
    params: query
  });
}
export function tedDriver(query) {
  return request({
    url: "/ntocc-basic-api/driver/driverList",
    method: "get",
    params: query
  });
}
export function vehicleTeam(query) {
  return request({
    url: "/ntocc-basic-api/vehicleTeam",
    method: "get",
    params: query
  });
}
export function UpstreamCustomer(query) {
  return request({
    url: "/ntocc-basic-api/upstreamCustomer/selectList",
    method: "get",
    params: query
  });
}

export function releaseSource(data) {
  return request({
    // url: '/ntocc-tms-api/order/submitOrder',
    url: "/ntocc-tms-api/order/submitOrderNew",
    method: "post",
    data
  });
}

// 添加合作司机
export function createDriverForRepeatGroup(data) {
  return request({
    // url: '/ntocc-tms-api/order/submitOrder',
    url: "/ntocc-tms-api/acceptVehicle/createDriverForRepeatGroup",
    method: "post",
    data
  });
}

// 获取合作司机列表
export function acceptVehicleDriverList(query) {
  return request({
    url: "/ntocc-tms-api/acceptVehicle/driverList",
    method: "get",
    params: query
  });
}

/**
 * 独立司机竞价
 * (string)mainOrderCode：货源order的code
 * (double)bidWeight：每车报价数量(单位:coalUnitName)
 * (double)bidPrice：报价单价：XX元/吨(单位:isTrunkName)
 * (string)arrivalTime：到达时间
 */
export function bidOrder(data) {
  return request({
    url: "/ntocc-tms-api/orderBid/bid",
    method: "post",
    params: data
  });
}
/**
 * 车队长竞价
 * (string)mainOrderCode：货源order的code
 * (integer)bidCount：车队长报价车数
 * (double)bidWeight：每车报价数量(单位:coalUnitName)
 * (double)bidPrice：报价单价：XX元/吨(单位:isTrunkName)
 * (string)arrivalTime：到达时间
 */
export function bidOrderBatch(data) {
  return request({
    url: "/ntocc-tms-api/orderBid/newMultiBid",
    method: "post",
    params: data
  });
}
/**
 * 独立司机接单
 * (string)mainOrderCode：货源order的code
 * (double)perWeight：每车接单数量(单位:coalUnitName)
 */

export function takeOrder(data) {
  return request({
    url: "/ntocc-tms-api/orderDetail/receive",
    method: "post",
    params: data
  });
}
/**
 * 批量接单
 * (string)mainOrderCode：货源order的code
 * (double)perWeight：每车接单数量(单位:coalUnitName)
 * (integer)coalNumber：接单车数
 */
export function takeOrderBatch(data) {
  return request({
    url: "/ntocc-tms-api/orderDetail/newMultiReceive",
    method: "post",
    params: data
  });
}
export function selectBid(data) {
  return request({
    url: "/ntocc-tms-api/orderBid/selectBid",
    method: "post",
    params: data
  });
}
export function Gould(data) {
  return request({
    url: "/ntocc-tps-api/amapApi/getGeocodes",
    method: "post",
    params: data
  });
}
export function qrcode(data) {
  return request({
    url: "/ntocc-tms-api/order/qrcode",
    method: "post",
    params: data
  });
}

export function SupplyManagement(query) {
  return request({
    url: "/ntocc-tms-api/order/list",
    method: "get",
    params: query
  });
}

//子公司货源管理
export function querySubLis(query) {
  return request({
    url: "/ntocc-tms-api/order/querySubList",
    method: "get",
    params: query
  });
}

export function pushTarGerList(query) {
  return request({
    url: "/ntocc-basic-api/driver/driverList",
    method: "get",
    params: query
  });
}
export function orderHallList(query) {
  return request({
    url: "/ntocc-tms-api/order/orderHallList",
    method: "get",
    params: query
  });
}
export function OrderDetails(code) {
  return request({
    url: `/ntocc-tms-api/order/${code}`,
    method: "get"
  });
}
export function orderSite(code) {
  return request({
    url: `/ntocc-tms-api/order/site/${code}`,
    method: "get"
  });
}
export function EditOriginalGoods(data) {
  return request({
    url: "/ntocc-tms-api/order/updateOrder",
    method: "put",
    data
  });
}
export function deleteOrder(data) {
  return request({
    url: `/ntocc-tms-api/order/`,
    method: "delete",
    params: {
      codes: data
    }
  });
}
export function cancelOrder(data) {
  return request({
    url: "/ntocc-tms-api/order/cancelOrder",
    method: "put",
    params: {
      codes: data
    }
  });
}
export function orderRefreshApi(data) {
  return request({
    url: "/ntocc-tms-api/order/flushOrder",
    method: "put",
    params: {
      codes: data
    }
  });
}
export function finishOrder(data) {
  return request({
    url: "/ntocc-tms-api/order/finishOrder",
    method: "put",
    params: {
      codes: data
    }
  });
}
export function dispatchOrder(data) {
  return request({
    url: "/ntocc-tms-api/order/dispatchOrder",
    method: "put",
    params: data
  });
}

export function savePushTarget(data) {
  return request({
    url: "/ntocc-tms-api/order/savePushTarget",
    method: "put",
    params: data
  });
}
export function commonRouteInfo(query) {
  return request({
    url: "/ntocc-basic-api/commonRouteInfo",
    method: "get",
    params: query
  });
}
export function OrderCode(code) {
  return request({
    url: `/ntocc-basic-api/commonRouteInfo/${code}`,
    method: "get"
  });
}
export function driverBidList(query) {
  return request({
    url: "/ntocc-tms-api/orderBid/driverBidList",
    method: "get",
    params: query
  });
}
export function ModifyPrice(data) {
  return request({
    url: "/ntocc-tms-api/order/releaseOrder",
    method: "put",
    params: data
  });
}
// 货源单调价
export function ModifypriceApi(data) {
  return request({
    url: "/ntocc-tms-api/order/updateOrderPrice",
    method: "put",
    params: data
  });
}
// 取消常发货源单设置
export function cancelOftenOrder(data) {
  return request({
    url: "/ntocc-tms-api/order/cancelOftenOrder",
    method: "put",
    params: {
      code: data
    }
  });
}
// 获取装卸货限制范围接口
export function GetRadius(data) {
  return request({
    url: "/ntocc-tms-api/order/fillAndSignLimitRange",
    method: "get",
    params: data
  });
}

// 获取地图标点是否开启
export function GetMapTag(data) {
  return request({
    url: "/ntocc-tms-api/order/fillAndSignLimitOnOff",
    method: "get",
    params: data
  });
}

export function GouldByPosition(data) {
  return request({
    url: "/ntocc-tps-api/amapApi/getDistance",
    method: "post",
    params: data
  });
}

// 超速提醒
export function overspeedRange(data) {
  return request({
    url: "/ntocc-tms-api/overspeedRange",
    method: "get",
    params: data
  });
}

// 轨迹事件
export function listAppLineErrorInfo(data) {
  return request({
    url: "/ntocc-tps-api/vehicleMap/listAppLineErrorInfo",
    method: "post",
    data: data
  });
}

// 偏离预警
export function orderTrackDeviationRecord(data) {
  return request({
    url: "/ntocc-tms-api/orderTrackDeviationRecord",
    method: "get",
    params: data
  });
}

// 删除合作司机
export function deleteAcceptVehicle(data) {
  return request({
    url: `/ntocc-tms-api/acceptVehicle`,
    method: "delete",
    params: data
  });
}
// 更新项目信息（项目名称/线路简称/来源单号）
export function updateProjectInfo(data) {
  return request({
    url: "/ntocc-tms-api/order/updateProjectInfo",
    method: "put",
    params: data
  });
}

export function uploadVehicleAgreement(data) {
  return request({
    url: "/ntocc-basic-api/driver/uploadVehicleAgreement",
    method: "post",
    data
  });
}

export function pendingConfirmList(params) {
  return request({
    url: "/ntocc-tms-api/driverVehicle/pendingConfirmList",
    method: "get",
    params
  });
}

export function batchConfirm(data) {
  return request({
    url: "/ntocc-tms-api/driverVehicle/batchConfirm",
    method: "post",
    data
  });
}

export function updateCoalTypeAndContact(data) {
  return request({
    url: "/ntocc-tms-api/order/updateCoalTypeAndContact ",
    method: "put",
    data
  });
}

/** 地址簿列表 */
export function getShipmentAddressBook(query) {
  return request({
    url: "/ntocc-basic-api/shipmentAddressBook",
    method: "get",
    params: query
  });
}

/** 新增地址簿 */
export function addShipmentAddressBook(data) {
  return request({
    url: "/ntocc-basic-api/shipmentAddressBook/add",
    method: "post",
    data
  });
}

/** 编辑地址簿 */
export function editShipmentAddressBook(data) {
  return request({
    url: "/ntocc-basic-api/shipmentAddressBook",
    method: "put",
    params: data
  });
}

/** 删除地址簿 */
export function deleteShipmentAddressBook(codes) {
  const codeStr = Array.isArray(codes) ? codes.join(",") : codes;
  return request({
    url: `/ntocc-basic-api/shipmentAddressBook?codes=${codeStr}`,
    method: "delete"
  });
}

/** 设置默认地址簿 */
export function setDefaultAddressBook(code) {
  return request({
    url: `/ntocc-basic-api/shipmentAddressBook/setDefault/${code}`,
    method: "put"
  });
}

/** 获取下一个可用货物类型编码 */
export function getNextAvailableCode(query) {
  return request({
    url: "/ntocc-basic-api/goodsType/getNextAvailableCode",
    method: "get",
    params: query
  });
}

/** 新增货物类型 */
export function addGoodsType(data) {
  return request({
    url: "/ntocc-basic-api/goodsType",
    method: "post",
    params: data
  });
}
